export const lazyInit = (initializer) => {
    let value;
    return async () => {
        if (value === undefined) {
            value = await initializer();
        }
        return value;
    };
};
//# sourceMappingURL=utils.js.map